module.exports = __webpack_public_path__ + "img/capac_teatroRositaAvila.028515cc.jpg";